import './Loading.scss';

const Loading = () => {
  return (
    <div className='cards-loading'>
      <div className='card-loading' />
      <div className='card-loading' />
      <div className='card-loading' />
    </div>
  );
};

export default Loading;
